/**
 * Biocemento conversion — drawer teinte, échantillon, kits par espace.
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'biocemento:teinte';
  const CONFIG_EL = document.getElementById('BioConversionConfig');
  if (!CONFIG_EL) return;

  const config = JSON.parse(CONFIG_EL.textContent);
  const assetBase = config.assetBase || '';
  const routes = config.routes || {};

  const SAMPLE_CENTS = 2000;
  const NUANCIER_CENTS = 12000;
  const NUANCIER_NEAR_CENTS = 10000;
  const NUANCIER_SLUG = 'nuancier-complet';

  let teintes = [];
  let nuancierMeta = null;
  let kitsCatalog = [];
  let variantMap = {};
  const variantCache = {};
  const selectedSlugs = new Set();
  let activeSlug = null;
  let drawerStripBuilt = false;
  let kitsScrollInited = false;
  let teinteScrollInited = false;

  function formatMoney(cents) {
    if (!cents && cents !== 0) return '20 €';
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function saveTeinte(slug) {
    try {
      localStorage.setItem(STORAGE_KEY, slug);
    } catch (e) { /* ignore */ }
    document.documentElement.dataset.bioTeinte = slug;
  }

  function getSavedTeinte() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function teinteUrlParam() {
    return new URLSearchParams(window.location.search).get('teinte');
  }

  function projectionUrl(filename) {
    const path = String(filename || '').replace(/^\//, '');
    if (!path) return assetBase;
    let url = assetBase + path;
    if (/nuancier-carousel-(vignette|lifestyle)\.jpe?g$/i.test(path)) {
      url += (url.includes('?') ? '&' : '?') + 'v=3';
    }
    return url;
  }

  function productUrl(t) {
    return `${routes.root}products/${t.productHandle}`;
  }

  function getDrawerSlides() {
    return nuancierMeta ? [...teintes, nuancierMeta] : teintes;
  }

  function isNuancierSlug(slug) {
    return slug === NUANCIER_SLUG;
  }

  function findDrawerItem(slug) {
    if (isNuancierSlug(slug)) return nuancierMeta;
    return teintes.find((x) => x.slug === slug);
  }

  async function fetchVariantForSlug(slug) {
    if (variantCache[slug]) return variantCache[slug];
    if (isNuancierSlug(slug)) {
      const v = await fetchNuancierVariant();
      if (v) variantCache[slug] = v;
      return v;
    }
    const t = teintes.find((x) => x.slug === slug);
    if (!t?.productHandle) return null;
    const res = await fetch(`${cartRoot()}products/${t.productHandle}.js`);
    if (!res.ok) return null;
    const product = await res.json();
    const v = product.variants?.[0];
    if (v) {
      variantCache[slug] = v;
      variantMap[slug] = v.id;
    }
    return v;
  }

  function nuancierMosaicHtml() {
    const picks = teintes.slice(0, 9);
    return (
      '<span class="bio-tone-drawer__slide-mosaic" aria-hidden="true">' +
      picks.map((t) => `<span style="--tone:${t.hex}"></span>`).join('') +
      '</span>'
    );
  }

  function nuancierSlideHtml() {
    const n = nuancierMeta;
    if (!n) return '';
    return slideHtml(
      {
        slug: n.slug,
        name: n.shortName || n.name,
        num: n.num,
        hex: n.hex || '#9a8f82',
        projection: n.carouselImage || n.image,
      },
      { isNuancier: true }
    );
  }

  function slideHtml(t, opts = {}) {
    const extra = opts.isNuancier ? ' data-is-nuancier' : '';
    return `
      <div class="bio-tone-drawer__slide" role="listitem" data-bio-drawer-chip data-slug="${t.slug}"${extra} style="--tone:${t.hex}">
        <div class="bio-tone-drawer__slide-frame">
          ${t.featured ? '<em class="bio-tone-drawer__slide-badge">Signature</em>' : ''}
          <button type="button" class="bio-tone-drawer__slide-check" data-bio-toggle-select aria-label="Ajouter ${t.name} à ma sélection" aria-pressed="false">
            <svg viewBox="0 0 20 20" aria-hidden="true"><path fill="currentColor" d="M7.5 14.2 3.8 10.5l1.2-1.2 2.5 2.5 6.5-6.5 1.2 1.2z"/></svg>
          </button>
          <button type="button" class="bio-tone-drawer__slide-preview" data-bio-slide-preview aria-label="Voir ${t.name}">
            <span class="bio-tone-drawer__slide-glow" aria-hidden="true"></span>
            <span class="bio-tone-drawer__slide-visual${opts.isNuancier ? ' bio-tone-drawer__slide-visual--nuancier' : ''}">
              <img src="${projectionUrl(t.projection)}" alt="" width="320" height="400" loading="lazy" decoding="async"${opts.isNuancier ? ' class="bio-tone-drawer__slide-img--nuancier"' : ''}>
              ${opts.isNuancier ? '' : '<span class="bio-tone-drawer__slide-tone" aria-hidden="true"></span>'}
            </span>
          </button>
        </div>
        <div class="bio-tone-drawer__slide-meta">
          <span class="bio-tone-drawer__slide-num">${t.num}</span>
          <span class="bio-tone-drawer__slide-name">${t.name}</span>
        </div>
      </div>`;
  }

  function bindDrawerSlides(strip) {
    strip.querySelectorAll('[data-bio-drawer-chip]').forEach((wrap) => {
      const slug = wrap.dataset.slug;
      wrap.querySelector('[data-bio-toggle-select]')?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleSelection(slug);
      });
      wrap.querySelector('[data-bio-slide-preview]')?.addEventListener('click', (e) => {
        e.preventDefault();
        switchDrawerTeinte(slug);
      });
    });
  }

  function carouselStep(wrap) {
    const slide = wrap.querySelector('[data-bio-drawer-chip]');
    if (!slide) return 140;
    const gap = parseFloat(getComputedStyle(wrap).gap) || 12;
    return slide.offsetWidth + gap;
  }

  function initDrawerCarouselNav(wrap) {
    const host = wrap.closest('[data-bio-drawer-carousel]');
    if (!host || host.dataset.carouselNavBound) return;
    host.dataset.carouselNavBound = '1';

    host.querySelector('[data-bio-strip-prev]')?.addEventListener('click', () => {
      wrap.scrollBy({ left: -carouselStep(wrap), behavior: 'smooth' });
    });
    host.querySelector('[data-bio-strip-next]')?.addEventListener('click', () => {
      wrap.scrollBy({ left: carouselStep(wrap), behavior: 'smooth' });
    });

    wrap.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        e.stopPropagation();
        wrap.scrollBy({ left: -carouselStep(wrap), behavior: 'smooth' });
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        e.stopPropagation();
        wrap.scrollBy({ left: carouselStep(wrap), behavior: 'smooth' });
      }
    });
  }

  function initDragScroll(wrap) {
    if (wrap.dataset.dragScrollBound) return;
    wrap.dataset.dragScrollBound = '1';
    let dragging = false;
    let startX = 0;
    let startScroll = 0;

    wrap.addEventListener('pointerdown', (e) => {
      if (e.button !== 0 || e.target.closest('button')) return;
      dragging = true;
      startX = e.clientX;
      startScroll = wrap.scrollLeft;
      wrap.setPointerCapture(e.pointerId);
      wrap.classList.add('is-dragging');
    });
    wrap.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      wrap.scrollLeft = startScroll - (e.clientX - startX);
    });
    const endDrag = (e) => {
      if (!dragging) return;
      dragging = false;
      wrap.classList.remove('is-dragging');
      try {
        wrap.releasePointerCapture(e.pointerId);
      } catch (err) { /* ignore */ }
    };
    wrap.addEventListener('pointerup', endDrag);
    wrap.addEventListener('pointercancel', endDrag);
  }

  function initInfiniteScroll(wrap) {
    requestAnimationFrame(() => {
      const seg = wrap.scrollWidth / 3;
      if (seg > 0) wrap.scrollLeft = seg;
    });
    let scrollRaf = 0;
    wrap.addEventListener(
      'scroll',
      () => {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(() => {
          scrollRaf = 0;
          const seg = wrap.scrollWidth / 3;
          if (seg < 1) return;
          const edge = Math.max(16, carouselStep(wrap) * 0.35);
          if (wrap.scrollLeft <= edge) wrap.scrollLeft += seg;
          else if (wrap.scrollLeft >= seg * 2 - edge) wrap.scrollLeft -= seg;
        });
      },
      { passive: true }
    );
    initDrawerCarouselNav(wrap);
    initDragScroll(wrap);
  }

  function buildDrawerCarousel() {
    const strip = document.querySelector('[data-bio-drawer-strip]');
    if (!strip || drawerStripBuilt) return;
    const block = getDrawerSlides()
      .map((item) => (item.isNuancier ? nuancierSlideHtml() : slideHtml(item)))
      .join('');
    strip.innerHTML = block + block + block;
    bindDrawerSlides(strip);
    if (!teinteScrollInited) {
      initInfiniteScroll(strip);
      teinteScrollInited = true;
    }
    drawerStripBuilt = true;
  }

  async function toggleNuancierSelection() {
    if (selectedSlugs.has(NUANCIER_SLUG)) {
      selectedSlugs.delete(NUANCIER_SLUG);
    } else {
      selectedSlugs.clear();
      selectedSlugs.add(NUANCIER_SLUG);
      await fetchVariantForSlug(NUANCIER_SLUG);
    }
    syncSelectionUI();
    updateCartBar();
  }

  async function toggleSelection(slug) {
    if (isNuancierSlug(slug)) {
      await toggleNuancierSelection();
      return;
    }
    selectedSlugs.delete(NUANCIER_SLUG);
    if (selectedSlugs.has(slug)) selectedSlugs.delete(slug);
    else {
      selectedSlugs.add(slug);
      await fetchVariantForSlug(slug);
    }
    syncSelectionUI();
    updateCartBar();
  }

  function syncSelectionUI() {
    document.querySelectorAll('[data-bio-drawer-chip]').forEach((wrap) => {
      const slug = wrap.dataset.slug;
      const on = selectedSlugs.has(slug);
      wrap.classList.toggle('is-selected', on);
      const check = wrap.querySelector('[data-bio-toggle-select]');
      if (check) check.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function getSelectionTotalCents() {
    if (selectedSlugs.has(NUANCIER_SLUG)) {
      return variantCache[NUANCIER_SLUG]?.price ?? NUANCIER_CENTS;
    }
    let total = 0;
    selectedSlugs.forEach((slug) => {
      total += variantCache[slug]?.price ?? SAMPLE_CENTS;
    });
    return total;
  }

  function hasNuancierSelected() {
    return selectedSlugs.has(NUANCIER_SLUG);
  }

  function getSelectedTeintes() {
    if (hasNuancierSelected() && nuancierMeta) {
      return [
        {
          slug: NUANCIER_SLUG,
          num: '21',
          name: nuancierMeta.title || 'Nuancier d\'exception',
          hex: '#8a7048',
          isNuancier: true,
        },
      ];
    }
    return [...selectedSlugs]
      .map((slug) => teintes.find((t) => t.slug === slug))
      .filter(Boolean)
      .sort((a, b) => parseInt(a.num, 10) - parseInt(b.num, 10));
  }

  function ticketKickerLine(count) {
    if (hasNuancierSelected()) return '21 teintes, un seul écrin';
    if (count === 1) return 'Une lumière pour commencer le voyage';
    if (count === 2) return 'Deux teintes, deux horizons';
    if (count >= 3) return `${count} teintes pour composer votre espace`;
    return '';
  }

  function renderTicketTones(container, selected) {
    if (!container) return;
    if (!selected.length) {
      container.innerHTML =
        '<p class="bio-tone-drawer__ticket-invite">Choisissez les teintes qui vous appellent.</p>';
      return;
    }
    if (selected[0]?.isNuancier) {
      container.innerHTML = `
        <p class="bio-tone-drawer__ticket-nuancier">${selected[0].name}</p>
        <p class="bio-tone-drawer__ticket-nuancier-sub">L’œuvre complète de l’atelier</p>`;
      return;
    }
    container.innerHTML =
      '<ul class="bio-tone-drawer__ticket-tone-list">' +
      selected
        .map(
          (t) => `
        <li class="bio-tone-drawer__ticket-tone" style="--tone:${t.hex}">
          <span class="bio-tone-drawer__ticket-tone-swatch" aria-hidden="true"></span>
          <span class="bio-tone-drawer__ticket-tone-num">${t.num}</span>
          <span class="bio-tone-drawer__ticket-tone-name">${t.name}</span>
        </li>`
        )
        .join('') +
      '</ul>';
  }

  function ticketNoteCopy(count, total) {
    if (hasNuancierSelected()) {
      return '21 teintes réunies dans un écrin d’atelier, coulées en Provence. Cent vingt euros, offerts en intégralité sur votre prochaine commande.';
    }
    if (total >= NUANCIER_CENTS) {
      return 'Vous touchez à l’œuvre complète, 21 teintes nées en Provence. Chaque euro vous revient sur commande.';
    }
    if (total >= NUANCIER_NEAR_CENTS) {
      const diff = NUANCIER_CENTS - total;
      return (
        'Encore ' +
        formatMoney(diff) +
        ' et l’œuvre complète est à vous. Un geste de plus, et le voyage est entier.'
      );
    }
    if (count >= 6) {
      return 'L’œuvre complète rassemble 21 lumières minérales. À ce seuil, c’est souvent le geste le plus évident.';
    }
    return 'Chaque échantillon est coulé à la main en Provence. Vingt euros, offerts en intégralité sur votre prochaine commande.';
  }

  function updateCartBar() {
    const nuancierOn = hasNuancierSelected();
    const count = nuancierOn ? 1 : selectedSlugs.size;
    const total = getSelectionTotalCents();
    const selected = getSelectedTeintes();
    const kickerEl = document.querySelector('[data-bio-cart-kicker]');
    const tonesEl = document.querySelector('[data-bio-cart-tones]');
    const totalEl = document.getElementById('bioToneDrawerPrice');
    const noteEl = document.querySelector('[data-bio-cart-note]');
    const clearBtn = document.querySelector('[data-bio-cart-clear]');
    const ticket = document.querySelector('[data-bio-drawer-cart]');
    const sampleBtn = document.getElementById('bioToneDrawerAtc');
    const nuancierBtn = document.getElementById('bioToneDrawerNuancierAtc');
    const ctaLabel = document.querySelector('[data-bio-cta-label]');

    if (ticket) {
      ticket.classList.toggle('is-empty', count === 0);
      ticket.classList.toggle('has-selection', count > 0);
    }

    if (kickerEl) {
      const kicker = ticketKickerLine(count);
      kickerEl.textContent = kicker;
      kickerEl.hidden = !kicker;
    }

    renderTicketTones(tonesEl, selected);
    if (totalEl) totalEl.textContent = count ? formatMoney(total) : '—';
    if (clearBtn) clearBtn.hidden = count === 0;

    const showNuancierPrimary = nuancierOn || total >= NUANCIER_CENTS;
    const showNuancierOffer = nuancierOn || total >= NUANCIER_NEAR_CENTS || selectedSlugs.size >= 5;
    if (nuancierBtn) nuancierBtn.hidden = !showNuancierOffer;
    if (sampleBtn) sampleBtn.hidden = showNuancierPrimary;
    const nuLabel = nuancierBtn?.querySelector('.bio-tone-drawer__cta-label');
    if (nuLabel && showNuancierPrimary) {
      nuLabel.textContent = 'S’offrir l’œuvre complète';
    } else if (nuLabel && showNuancierOffer) {
      nuLabel.textContent = 'Passer à l’œuvre complète';
    }

    if (noteEl) {
      if (count === 0) {
        noteEl.hidden = true;
        noteEl.textContent = '';
      } else {
        noteEl.hidden = false;
        noteEl.textContent = ticketNoteCopy(count, total);
      }
    }

    if (ctaLabel) {
      if (count === 0) {
        ctaLabel.textContent = 'Choisissez vos teintes';
        if (sampleBtn) sampleBtn.disabled = true;
      } else if (nuancierOn) {
        ctaLabel.textContent = 'Recevoir l’écriture complète';
        if (sampleBtn) sampleBtn.disabled = false;
      } else if (count === 1) {
        ctaLabel.textContent = 'Recevoir cette lumière';
        if (sampleBtn) sampleBtn.disabled = false;
      } else {
        ctaLabel.textContent = 'Recevoir ma sélection';
        if (sampleBtn) sampleBtn.disabled = false;
      }
    }
  }

  function highlightDrawerSlide(slug) {
    document.querySelectorAll('[data-bio-drawer-chip]').forEach((c) => {
      c.classList.toggle('is-active', c.dataset.slug === slug);
    });
    const actives = document.querySelectorAll(`[data-bio-drawer-chip][data-slug="${slug}"]`);
    const mid = actives[Math.floor(actives.length / 2)] || actives[0];
    mid?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  function updateDrawerIndex(t) {
    const el = document.querySelector('[data-bio-drawer-index]');
    const total = getDrawerSlides().length;
    if (el && t) el.textContent = `${t.num} / ${total}`;
  }

  function setStageImage(t) {
    const img = document.getElementById('bioToneDrawerImg');
    if (!img) return;
    img.classList.remove('is-active');
    const src = projectionUrl(t.isNuancier ? t.image || t.projection : t.projection);
    const preload = new Image();
    preload.onload = () => {
      img.src = src;
      img.alt = t.isNuancier
        ? `${t.title || t.name}, nuancier complet`
        : `${t.name}, projection intérieure`;
      img.classList.toggle('is-nuancier-stage', !!t.isNuancier);
      requestAnimationFrame(() => img.classList.add('is-active'));
    };
    preload.src = src;
  }

  function kitCardHtml(k, teinteQ, index) {
    const pageUrl = `${routes.root}pages/${k.pageHandle}?${teinteQ}`;
    const price = k.priceFrom ? formatMoney(k.priceFrom) : '';
    const bg = k.image ? projectionUrl(k.image) : '';
    const idx = String(index).padStart(2, '0');
    return `
      <a class="bio-tone-drawer__kit-card" href="${pageUrl}">
        <div class="bio-tone-drawer__kit-media">
          ${bg ? `<img class="bio-tone-drawer__kit-img" src="${bg}" alt="" loading="lazy">` : '<span class="bio-tone-drawer__kit-img bio-tone-drawer__kit-img--placeholder" aria-hidden="true"></span>'}
          <span class="bio-tone-drawer__kit-index">${idx}</span>
        </div>
        <div class="bio-tone-drawer__kit-body">
          <span class="bio-tone-drawer__kit-eyebrow">${k.badge || k.subtitle || ''}</span>
          <strong class="bio-tone-drawer__kit-title">${k.title}</strong>
          <p class="bio-tone-drawer__kit-desc">${k.subtitle || ''}</p>
          <footer class="bio-tone-drawer__kit-foot">
            <span class="bio-tone-drawer__kit-price">À partir de ${price}</span>
            <span class="bio-tone-drawer__kit-arrow" aria-hidden="true">→</span>
          </footer>
        </div>
      </a>`;
  }

  function renderDrawerKits(slug) {
    const wrap = document.querySelector('[data-bio-drawer-kits]');
    if (!wrap || !kitsCatalog.length) return;
    const teinteQ = `teinte=${encodeURIComponent(slug)}`;
    const block = kitsCatalog.map((k, i) => kitCardHtml(k, teinteQ, i + 1)).join('');
    wrap.innerHTML = block + block + block;
    if (!kitsScrollInited) {
      initInfiniteScroll(wrap);
      kitsScrollInited = true;
    }
  }

  async function switchDrawerTeinte(slug) {
    await openDrawer(slug, { skipShow: true });
  }

  function navigateDrawer(delta) {
    const slides = getDrawerSlides();
    const idx = slides.findIndex((t) => t.slug === activeSlug);
    if (idx < 0) return;
    const next = slides[(idx + delta + slides.length) % slides.length];
    switchDrawerTeinte(next.slug);
  }

  async function openDrawer(slug, opts = {}) {
    const t = findDrawerItem(slug);
    if (!t) return;
    activeSlug = slug;
    if (!t.isNuancier) saveTeinte(slug);
    buildDrawerCarousel();

    const drawer = document.getElementById('bioToneDrawer');
    if (!drawer) return;

    const numEl = document.getElementById('bioToneDrawerNum');
    if (t.isNuancier) {
      numEl.textContent = nuancierMeta?.tagline || '21 teintes';
      document.getElementById('bioToneDrawerTitle').textContent = t.title || t.name;
    } else {
      numEl.textContent = `Teinte ${t.num}`;
      document.getElementById('bioToneDrawerTitle').textContent = t.name;
    }
    const tagEl = document.getElementById('bioToneDrawerTagline');
    if (tagEl) tagEl.textContent = t.isNuancier ? (config.nuancierPrice || '120 €') : t.tagline || '';
    document.getElementById('bioToneDrawerCopy').textContent = t.drawerCopy || t.copy || '';
    setStageImage(t);

    await fetchVariantForSlug(slug);

    highlightDrawerSlide(slug);
    updateDrawerIndex(t);
    if (!t.isNuancier) {
      renderDrawerKits(slug);
    } else {
      const kitSlug = getSavedTeinte() || teintes.find((x) => x.featured)?.slug || teintes[0]?.slug;
      if (kitSlug) renderDrawerKits(kitSlug);
    }
    syncSelectionUI();
    updateCartBar();

    const status = document.getElementById('bioToneDrawerStatus');
    status.hidden = true;
    status.textContent = '';

    if (!opts.skipShow && !drawer.open) {
      drawer.showModal();
      document.body.classList.add('bio-tone-drawer-open');
    }
  }

  function closeDrawer() {
    const drawer = document.getElementById('bioToneDrawer');
    if (drawer?.open) drawer.close();
    document.body.classList.remove('bio-tone-drawer-open');
  }

  async function fetchNuancierVariant() {
    const handle = config.nuancierHandle || 'nuancier-complet-biocemento';
    const res = await fetch(`${cartRoot()}products/${handle}.js`);
    if (!res.ok) return null;
    const product = await res.json();
    return product.variants?.[0];
  }

  function cartRoot() {
    return (window.Shopify?.routes?.root || routes.root || '/').replace(/\/?$/, '/');
  }

  async function addItemsToCart(items, statusEl, options = {}) {
    const { openCartDrawer = true, closeToneDrawer = true } = options;
    const root = cartRoot();

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items,
        sections: sectionsToBundle.join(','),
      }),
    });

    const json = await res.json();
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

    if (!res.ok) throw new Error(json.description || json.message || 'Erreur panier');

    const cartContent = await (await fetch(`${root}cart.js`)).json();
    if (json.sections) cartContent.sections = json.sections;

    const addedItems = json.items || (json.id ? [json] : items);
    const onSuccessDo = openCartDrawer ? 'force_open_drawer' : undefined;

    document.documentElement.dispatchEvent(
      new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items: addedItems, cart: cartContent, onSuccessDo },
      })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          onSuccessDo,
          cart: cartContent,
        },
      })
    );

    if (statusEl) {
      statusEl.hidden = false;
      statusEl.textContent = 'Ajouté au panier. Apple Pay et carte bancaire ci-dessous.';
    }

    if (closeToneDrawer) {
      setTimeout(() => closeDrawer(), openCartDrawer ? 400 : 1200);
    }

    if (!json.sections || !Object.keys(json.sections).length) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    return cartContent;
  }

  async function addSelectionToCart() {
    const status = document.getElementById('bioToneDrawerStatus');
    const btn = document.getElementById('bioToneDrawerAtc');
    if (hasNuancierSelected()) {
      return addNuancierToCart();
    }
    const slugs = selectedSlugs.size ? [...selectedSlugs] : activeSlug && !isNuancierSlug(activeSlug) ? [activeSlug] : [];

    if (!slugs.length) {
      status.hidden = false;
      status.textContent = 'Cochez au moins une teinte dans le carrousel.';
      return;
    }

    btn?.setAttribute('aria-busy', 'true');
    if (btn) btn.disabled = true;

    try {
      const items = [];
      for (const slug of slugs) {
        const v = await fetchVariantForSlug(slug);
        if (v?.id) items.push({ id: Number(v.id), quantity: 1 });
      }
      if (!items.length) throw new Error('Produits indisponibles');
      await addItemsToCart(items, status);
    } catch (err) {
      status.hidden = false;
      status.textContent = err.message || 'Impossible d’ajouter au panier.';
    } finally {
      btn?.removeAttribute('aria-busy');
      updateCartBar();
    }
  }

  async function addNuancierToCart(triggerBtn) {
    if (typeof window.bioAddNuancierToCart === 'function') {
      try {
        await window.bioAddNuancierToCart(triggerBtn);
        updateCartBar();
        return;
      } catch (err) {
        const status = document.getElementById('bioToneDrawerStatus');
        if (status) {
          status.hidden = false;
          status.textContent = err.message || 'Erreur nuancier.';
        }
        throw err;
      }
    }

    const status = document.getElementById('bioToneDrawerStatus');
    const btn = triggerBtn || document.getElementById('bioToneDrawerNuancierAtc');
    btn?.setAttribute('aria-busy', 'true');
    if (btn) btn.disabled = true;
    try {
      let variantId = btn?.dataset?.variantId || config.nuancierVariantId;
      if (!variantId) {
        const v = await fetchNuancierVariant();
        variantId = v?.id;
      }
      if (!variantId) throw new Error('Nuancier indisponible');
      await addItemsToCart([{ id: Number(variantId), quantity: 1 }], status);
    } catch (err) {
      if (status) {
        status.hidden = false;
        status.textContent = err.message || 'Erreur nuancier.';
      } else {
        console.error(err);
      }
    } finally {
      if (btn) btn.disabled = false;
      btn?.removeAttribute('aria-busy');
      updateCartBar();
    }
  }

  function bindNuancierAtcButtons() {
    document.querySelectorAll('[data-bio-nuancier-atc]').forEach((el) => {
      if (el.dataset.bioAtcBound === '1' || el.dataset.bioNuancierBound === '1') return;
      el.dataset.bioNuancierBound = '1';
      el.addEventListener('click', (e) => {
        e.preventDefault();
        addNuancierToCart(el);
      });
    });
  }

  function openConseil(e) {
    if (e) e.preventDefault();
    const t = findDrawerItem(activeSlug);
    const waText = t
      ? t.isNuancier
        ? 'Bonjour Biocemento, je souhaite un conseil pour le nuancier complet (21 teintes).'
        : `Bonjour Biocemento, je souhaite un conseil pour la teinte ${t.num}, ${t.name}.`
      : 'Bonjour Biocemento, je souhaite être accompagné sur mon projet.';

    const waBase = (config.whatsappUrl || '').split('?')[0];
    if (waBase) {
      window.open(`${waBase}?text=${encodeURIComponent(waText)}`, '_blank', 'noopener,noreferrer');
      return;
    }

    const subject = t
      ? t.isNuancier
        ? 'Conseil nuancier complet'
        : `Conseil teinte ${t.num}, ${t.name}`
      : 'Conseil projet Biocemento';
    const url = new URL(config.conseilUrl || routes.conseil || '/pages/contact', window.location.origin);
    url.searchParams.set('subject', subject);
    if (activeSlug) url.searchParams.set('teinte', activeSlug);
    window.location.href = url.toString();
  }

  function bindTeinteClicks(root) {
    root.querySelectorAll('.bio-matiere-tone-card, .bio-matiere-tone-feature').forEach((el) => {
      const slug = el.dataset.bioTeinte;
      if (!slug) return;
      el.addEventListener('click', (e) => {
        if (e.target.closest('a')) return;
        e.preventDefault();
        openDrawer(slug);
      });
      el.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openDrawer(slug);
        }
      });
    });
  }

  function renderCarousel(container) {
    if (!container || !teintes.length) return;
    container.innerHTML = '';
    const ordered = [...teintes].sort((a, b) => parseInt(a.num, 10) - parseInt(b.num, 10));

    ordered.forEach((t) => {
      if (t.featured) {
        const feat = document.createElement('article');
        feat.className = 'bio-matiere-tone-feature';
        feat.dataset.bioTeinte = t.slug;
        feat.innerHTML = `
          <img src="${projectionUrl(t.projection)}" alt="Teinte ${t.name}" width="1458" height="930" loading="lazy">
          <p>Best-seller</p><span>${t.num}</span><h3>${t.name}</h3><small>${t.copy}</small>`;
        container.appendChild(feat);
        return;
      }
      const card = document.createElement('article');
      card.className = 'bio-matiere-tone-card bio-matiere-tone-card--room';
      card.style.setProperty('--tone', t.hex);
      card.dataset.bioTeinte = t.slug;
      card.innerHTML = `
        <img src="${projectionUrl(t.projection)}" alt="${t.name}" width="1458" height="930" loading="lazy">
        <span>${t.num}</span><strong>${t.name}</strong>`;
      container.appendChild(card);
    });
    bindTeinteClicks(container);
  }

  function initDrawer() {
    const drawer = document.getElementById('bioToneDrawer');
    if (!drawer) return;

    drawer.querySelectorAll('[data-bio-tone-close]').forEach((btn) => btn.addEventListener('click', closeDrawer));
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer) closeDrawer();
    });
    drawer.addEventListener('cancel', (e) => {
      e.preventDefault();
      closeDrawer();
    });

    document.querySelector('[data-bio-drawer-prev]')?.addEventListener('click', () => navigateDrawer(-1));
    document.querySelector('[data-bio-drawer-next]')?.addEventListener('click', () => navigateDrawer(1));

    document.getElementById('bioToneDrawerAtc')?.addEventListener('click', addSelectionToCart);
    document.querySelector('[data-bio-cart-clear]')?.addEventListener('click', () => {
      selectedSlugs.clear();
      syncSelectionUI();
      updateCartBar();
    });
    document.querySelectorAll('[data-bio-open-conseil]').forEach((btn) => btn.addEventListener('click', openConseil));

    drawer.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') navigateDrawer(-1);
      if (e.key === 'ArrowRight') navigateDrawer(1);
    });
  }

  /** N'ouvre le drawer qu'avec ?teinte= explicite — pas au chargement de Matière. */
  function initGlobalTeinteLinks() {
    const slug = teinteUrlParam();
    if (slug && findDrawerItem(slug)) {
      if (!isNuancierSlug(slug)) saveTeinte(slug);
      requestAnimationFrame(() => openDrawer(slug));
    }
  }

  async function loadNuancierMeta() {
    if (!config.nuancierDataUrl) return;
    try {
      const res = await fetch(config.nuancierDataUrl);
      const data = await res.json();
      nuancierMeta = {
        isNuancier: true,
        slug: data.slug || NUANCIER_SLUG,
        num: data.num || '22',
        shortName: data.shortName || 'Boîte complète',
        title: data.title || 'Nuancier d\'exception',
        name: data.shortName || 'Boîte complète',
        tagline: data.tagline || '21 teintes',
        drawerCopy: data.drawerCopy || data.creditNote || '',
        copy: data.drawerCopy || '',
        image: data.image,
        carouselImage: data.carouselImage || data.image,
        projection: data.carouselImage || data.image,
        hex: data.hex || '#9a8f82',
        productHandle: data.productHandle || config.nuancierHandle,
      };
    } catch (e) {
      nuancierMeta = null;
    }
  }

  function wireHeroSample() {
    document.querySelectorAll('[data-bio-open-sample]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const slug = teintes.find((t) => t.featured)?.slug || teintes[0]?.slug;
        if (slug) openDrawer(slug);
        else if (config.sampleFallbackUrl) window.location.href = config.sampleFallbackUrl;
      });
    });
  }

  document.addEventListener('bio:open-sample', (e) => {
    if (e.detail?.slug) openDrawer(e.detail.slug);
  });

  async function init() {
    try {
      const res = await fetch(config.teintesUrl);
      teintes = await res.json();
      teintes.sort((a, b) => parseInt(a.num, 10) - parseInt(b.num, 10));
    } catch (e) {
      teintes = [];
    }

    await loadNuancierMeta();

    if (config.kitsCatalogUrl) {
      try {
        const kRes = await fetch(config.kitsCatalogUrl);
        const kJson = await kRes.json();
        const kitOrder = ['sdb', 'sol', 'mur', 'plan', 'exterieur'];
        const raw = kJson.kits || kJson;
        kitsCatalog = kitOrder.map((key) => raw[key]).filter(Boolean);
        if (!kitsCatalog.length) kitsCatalog = Object.values(raw);
      } catch (e) {
        kitsCatalog = [];
      }
    }

    const carousel = document.getElementById('bioTeintesCarousel');
    if (carousel) {
      if (carousel.children.length > 0) bindTeinteClicks(carousel);
      else renderCarousel(carousel);
    }

    initDrawer();
    if (typeof window.bioAddNuancierToCart !== 'function') {
      bindNuancierAtcButtons();
    }
    initGlobalTeinteLinks();
    wireHeroSample();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.BiocementoConversion = {
    openTeinte: openDrawer,
    getTeinte: getSavedTeinte,
    saveTeinte,
    addNuancierToCart,
  };
  window.bioOpenSampleDrawer = openDrawer;
  window.bioAddNuancierToCart = addNuancierToCart;
})();
